export const PhaseCards = () => {
  const PHASES = [
    { 
      id: 1, 
      title: 'Phase 1', 
      description: 'Create new resources in partnership with parents, such as online learning modules, text messages and personalised feedback', 
      image: '/images/phase-1.jpg'
    },
    { 
      id: 2, 
      title: 'Phase 2', 
      description: 'Find out which parenting resources are most effective for improving adolescent behaviours, and finalise the intervention', 
      image: '/images/phase-2.jpg' 
    },
    { 
      id: 3, 
      title: 'Phase 3', 
      description: 'Test the Health4Life Parent & Teens program’s effectiveness & cost-effectiveness for improving adolescent health', 
      image: '/images/phase-3.jpg' 
    },
  ];

  return(
    <ul className="flex flex-wrap -mx-4 list-style-none">
      {PHASES.map(({ description, id, image, title }) => (
        <li key={id} className="w-full md:w-1/2 lg:w-1/3 m-0 p-4">
          <div className="rounded-lg overflow-hidden h-full flex flex-col">
            <img 
              alt={description}
              className="bg-grey-500 object-cover flex-1" 
              src={image}
            />
            <div className="bg-white border border-grey-500 rounded-lg text-center p-8 -mt-4">
              <p className="h3 mb-2">{title}</p>
              <p>{description}</p>
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
};